import { render, staticRenderFns } from "./devedores-propina.vue?vue&type=template&id=690922ee&scoped=true&"
import script from "./devedores-propina.vue?vue&type=script&lang=js&"
export * from "./devedores-propina.vue?vue&type=script&lang=js&"
import style0 from "./devedores-propina.vue?vue&type=style&index=0&id=690922ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690922ee",
  null
  
)

export default component.exports